// ============================================================================
// GESTIMMONY — Page /payment/cancel (retour Stripe abandon)
// ============================================================================
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white flex items-center justify-center px-4" data-testid="payment-cancel-page">
      <Card className="max-w-lg w-full p-8 text-center">
        <div className="h-16 w-16 rounded-full bg-amber-100 mx-auto flex items-center justify-center mb-4">
          <XCircle className="h-9 w-9 text-amber-600" />
        </div>
        <h1 className="font-heading text-3xl font-bold text-slate-900">Paiement annulé</h1>
        <p className="text-slate-600 mt-3">
          Aucun montant ne vous a été prélevé. Vous pouvez reprendre à tout moment,
          nous gardons votre compte prêt.
        </p>
        <div className="flex flex-col sm:flex-row gap-2 justify-center mt-6">
          <Link to="/tarifs"><Button variant="outline"><ArrowLeft className="h-4 w-4 mr-2" /> Revoir les tarifs</Button></Link>
          <Link to="/app"><Button className="bg-[hsl(var(--primary))]">Continuer en essai</Button></Link>
        </div>
      </Card>
    </div>
  );
}
